class ContactModal
{
    
    /**
     * @var {bool}
     */
    open = false;

    init() {
        this.events();
    }

    events() {
        const modalTriggers = document.querySelectorAll('a[href*="#contactModal"]');

        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                e.preventDefault();
                this.handleContactModalOpen();
            });
        });
    }

    handleContactModalOpen() {
        this.open = true;
    }

    handleContactModalClose() { 
        this.open = false;
    }

}

document.addEventListener("alpine:init", () => {
    Alpine.data("contactModal", () => new ContactModal());
});
